module.exports = __webpack_public_path__ + "static/seo-gym-club-83886d71f534e1ce4acf1812f136a1fb.png";